/**
 * @typedef {
 *   ANALISAR |
 *   PENDENTE_DE_ESCLARECIMENTO |
 *   EM_ANALISE |
 *   APTO_PARA_REVISAO |
 *   REVISADO |
 *   ANALISADO
 * } EtapaAnalise
 */
const ETAPA_ANALISE = {
  ANALISAR: 'ANALISAR',
  PENDENTE_DE_ESCLARECIMENTO: 'PENDENTE_DE_ESCLARECIMENTO',
  EM_ANALISE: 'EM_ANALISE',
  APTO_PARA_REVISAO: 'APTO_PARA_REVISAO',
  REVISADO: 'REVISADO',
  ANALISADO: 'ANALISADO',
};

export default ETAPA_ANALISE;
